(function () {
    'use strict';

    angular
        .module('app.language')
        .directive('obtLanguage', obtLanguage);

    function obtLanguage () {
       return  {
            controller:languageController,
            controllerAs:'vmLanguages',
            scope:{
                cid:'@?',
                tid:'@?'
            },
            bindToController:true,
            replace:true,
            template:'<li class="dropdown tasks-menu">\n    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">\n        <i class="fa fa-flag-o"></i>\n        <span class="label label-danger">{{vmLanguages.selectedLanguageId}}</span>\n    </a>\n    <ul class="dropdown-menu">\n        <li>\n            <ul class="menu">\n                <li ng-repeat="language in vmLanguages.languages">\n                    <a href="javascript:void(0)" ng-click="vmLanguages.updateLanguage(language.CODE)">\n                        <h3>\n                            {{language.VALUE}}\n                            <small class="pull-right">{{language.CODE}}</small>\n                        </h3>\n                    </a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</li>      ',
            restrict: 'AE'
        };
    }

    languageController.$inject=['languageServices', '$stateParams', 'config'];
    /*@ngInject*/
    function languageController(languageServices, $stateParams, config){
        var vm = this;
        vm.languages = [];
        vm.selectedLanguageId = $stateParams.language || config.language;//obtSession.get('language');
        vm.updateLanguage = updateLanguage;
        vm.getCurrentLanguage = getCurrentLanguage ;
        getLanguages(); //fill the combobox
      function getCurrentLanguage(){
      return  vm.selectedLanguageId ;
      }
        function updateLanguage (key){
            if(key){
                vm.selectedLanguageId = key;
                languageServices.updateLanguage(vm.selectedLanguageId);
            }
        }

        function getLanguages(){
            var args = {cId:vm.cid || null, tId:vm.tid || null };
            languageServices.getLanguagesPromise(args)
                .then(function(result){
                    vm.languages = result;
                }
            );
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/language/obt-Language.directive.js
 ** module id = 213
 ** module chunks = 0
 **/